var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" }, props),
    React.createElement(
      "g",
      { fill: "#67707c" },
      React.createElement("path", { d: "M16.57 7.39v5.28h4.52l-4.52-5.28z" }),
      React.createElement("path", { d: "M22 14.67h-7.43V7H8v16h14v-8.33z" })
    ),
    React.createElement(
      "text",
      { transform: "translate(9.67 21.13)", fontSize: "6", fill: "#fff", fontFamily: "Lato" },
      "XLS"
    )
  );
});


// WEBPACK FOOTER //
// ./icons/images/invoices/document/xls.svg